import ReaderPage from './ReaderPage'
import withReaderPage from './withReaderPage'

const ConnectedReaderPage = withReaderPage(ReaderPage)

export { ConnectedReaderPage as ReaderPage }
